const AIXX = [
    {
      page: 2,
      lib: "Première énigme !",
      texteIndice: ["Soustraction", "Retirez les lettres de Voix et Cape", "Rennes"]
    },
    {
      page: 5,
      lib: "A bien voir...",
      texteIndice: ["Regardez bien", "Comparez avec le réel", "Un 'chat' au milieu de la page"]
    },
    {
      page: 8,
      lib: "Le mouton",
      texteIndice: [
        "Origami",
        "Pliez vous à l'exercice",
        "La lettre 'i' (pliez la page pour 3+6=9)"
      ]
    },
    {
      page: 11,
      lib: "Témoignages",
      texteIndice: [
        "Un problème d'étages...",
        "Un problème de direction...",
        "La lettre 'Z'"
      ]
    },
    {
      page: 13,
      lib: "Le tournant de l'affaire",
      texteIndice: ["Trouvez sur la façade", "Les chiffres deviennent des lettres","Windows"]
    },
    {
      page: 16,
      lib: "Les visages",
      texteIndice: ["Pas des visages au milieu", "C'est une fontaine", "La lettre 'M', 1912 sur fontaine"]
    },
    {
      page: 18,
      lib: "L'intrus'",
      texteIndice: ["Une plaque de rue vous aidera", "Pichouno carrriera dei...", "Une mine peut faire sauter un char !", "Lettre S, car l'usine n'est pas une arme"]
    },
    {
      page: 19,
      lib: "Couvre chef",
      texteIndice: ["Façade derrière vous", "C'est presque effacé", "Chappelerie"]
    },
    {
      page: 23,
      lib: "Les croix",
      texteIndice: ["Comptez les croix", "N'oubliez pas celle sur la fontaine", "La lettre V, 5 croix"]
    },
    {
      page: 24,
      lib: "Cardinal",
      texteIndice: ["L'hôtel", "Bouchez les trous", "Chataignier"]
    },
    {
      page: 26,
      lib: "Botanique",
      texteIndice: ["Fruit sculpté", "Pas l'hôtel", "Le pin"]
    },
    {
      page: 28,
      lib: "La mousse",
      texteIndice: ["C'est rapide!", "Je double", "La lettre L, le mois prochain"]
    },
    {
      page: 30,
      lib: "Mots croisés",
      texteIndice: ["René", "Monoprix, Durance ", "Défi"]
    },
    {
      page: 32,
      lib: "La carte",
      texteIndice: ["Utilisez la carte", "Superposez", "La lettre G"]
    },
    {
      page: 34,
      lib: "La question",
      texteIndice: ["Réponse dans le texte", "Lecture verticale", "La lettre N"]
    },
    {
      page: 36,
      lib: "La rotonde",
      texteIndice: ["Régulièrement rencontrée ce jour", "Carburant vital", "EAU"]
    },
    {
      page: 37,
      lib: "La video-surveillance",
      texteIndice: ["Objet à trouver", "Un cadenas", "La lettre T"]
    },
    {
      page: 39,
      lib: "Dernière énigme !",
      texteIndice: ["Vous avez la réponse en main", "1ere étape: Le stylo", "Dévissez le stylo !"]
    }
  ];


export default AIXX;